export const DEFAULT_MEDIA_ACCEPT = {
    'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp'],
    'application/pdf': ['.pdf'],
    'video/*': ['.mp4', '.webm', '.mov', '.m4v', '.ogg']
};

export const MEDIA_ACCEPT_ATTR = 'image/*,video/*,application/pdf,.pdf,.mp4,.webm,.mov,.m4v';

export function getFileKind(file = {}) {
    const mime = String(file.mimeType || file.file?.type || file.type || '').toLowerCase();
    const name = String(file.name || file.url || file.viewURL || '').toLowerCase();

    if (mime.startsWith('image/') || /\.(jpe?g|png|gif|webp|bmp)(\?|$)/i.test(name)) {
        return 'image';
    }
    if (mime.startsWith('video/') || /\.(mp4|webm|mov|m4v|ogg|ogv)(\?|$)/i.test(name)) {
        return 'video';
    }
    if (mime === 'application/pdf' || mime.includes('pdf') || /\.pdf(\?|$)/i.test(name)) {
        return 'pdf';
    }
    return 'other';
}

export function guessMimeFromName(name = '') {
    const lower = String(name).toLowerCase();
    if (/\.(jpe?g)$/i.test(lower)) return 'image/jpeg';
    if (/\.png$/i.test(lower)) return 'image/png';
    if (/\.gif$/i.test(lower)) return 'image/gif';
    if (/\.webp$/i.test(lower)) return 'image/webp';
    if (/\.pdf$/i.test(lower)) return 'application/pdf';
    if (/\.mp4$/i.test(lower)) return 'video/mp4';
    if (/\.webm$/i.test(lower)) return 'video/webm';
    if (/\.mov$/i.test(lower)) return 'video/quicktime';
    if (/\.m4v$/i.test(lower)) return 'video/x-m4v';
    return '';
}
